import React from "react";
import { Badge, Divider, Form } from "antd";
import { downloadImg } from "@/utils/constant";
import * as DICT from "@/utils/dict"
import CONST from "@/dataSource/CONST"
import defaultImg from '@/assets/images/pic-error.png'
import { ImageList } from "@/components/Img";
import intl from "react-intl-universal";
import styles from "./alarmStatus.module.less";
import PropIcon from "@/components/Icon/PropIcon";
import http from "@/http"
import Tag from "@/components/Tag";
import BaseStatus from "../../overview/device/deviceInfo/components/BaseStatus";


class AlarmStatus extends React.Component {
    componentDidMount() {
    }

    render() {
        const { alarmInfo } = this.props;
        if (!(alarmInfo && alarmInfo.id && alarmInfo.id.length > 0)) return ``;
        if (!(alarmInfo.state === `HANDLE`)) return ``;

        let imageListData = []
        if (alarmInfo.handleImageList && alarmInfo.handleImageList.length > 0)
            alarmInfo.handleImageList.forEach(element => { imageListData.push({ src: downloadImg + element }); });

        return (
            <div className={styles.deviceInfoMain}>
                <div className={styles.row}>
                    <Tag className={styles.tag} color={alarmInfo.state}>
                        {DICT.getValue(`DEVICE_ALARM_STATE`, alarmInfo.state)}
                    </Tag>
                    {alarmInfo.handleMethod ?
                        <Tag className={styles.tag} color={`GRAY6`}>
                            {DICT.getValue(`DEVICE_ALARM_HANDLE_METHOD`, alarmInfo.handleMethod)}
                        </Tag>
                        : ``}
                    {alarmInfo.handleUser ? <div className={styles.text}>{alarmInfo.handleUser}</div> : ``}
                    <div className={styles.text}>{alarmInfo.handleTime}</div>
                </div>
                { alarmInfo.handleRemark ?
                    <div className={styles.row}> <div className={styles.text}>{alarmInfo.handleRemark}</div></div>
                    : ``}
                {imageListData && imageListData.length > 0 ?
                    <div className={styles.imgRow}>
                        <span className={styles.name}>处理照片:</span>
                        <ImageList className={styles.imgList} imageInfoList={imageListData} showImage={(imageList, onImgClick) => {
                            if (!(imageList && imageList.length > 0)) return "";
                            return imageList.map((item, index) => {
                                return (
                                    <img className={styles.image} src={item.src} alt="" onClick={(e) => onImgClick(index)} />
                                )
                            })
                        }} />
                    </div>
                    : ``}
            </div>
        )
    }
}

export default AlarmStatus